import { CustomCheckbox, Flex } from 'portal-commons';
import { FunctionComponent } from 'react';

interface OptionProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

const Option: FunctionComponent<OptionProps> = ({
  checked = false,
  onChange,
  children,
}) => (
  <Flex
    sx={{
      flexDirection: 'row',
      alignItems: 'center',
      gap: '10px',
      color: 't.black80',
      fontWeight: 400,
      fontSize: 'H400',
      lineHeight: 'normal',
    }}
  >
    <CustomCheckbox
      checked={checked}
      onChange={(event) => onChange?.(event.target.checked)}
    />
    {children}
  </Flex>
);

export default Option;
